import { type InsuranceCorporateIdentity } from "../types";

export function MhplusLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <clipPath id="clip0_31_4299">
          <rect
            width="446"
            height="131"
            fill="white"
            transform="translate(33 190)"
          />
        </clipPath>
      </defs>
      <g clipPath="url(#clip0_31_4299)">
        <path
          d="M33 217.208V294.861H55.6093V253.742C55.6093 245.334 55.1479 233.717 66.9908 233.717C78.6799 233.717 77.1419 245.64 77.1419 253.742V294.861H99.7513V253.742C99.7513 249.615 99.5973 243.5 101.289 239.831C102.981 236.163 107.134 233.869 111.133 233.869C115.901 233.869 119.592 235.245 120.822 240.137C121.591 243.042 121.284 250.684 121.284 253.742V294.861H143.893V246.404C143.893 238.608 144.969 229.743 139.74 223.628C135.126 218.125 127.59 215.68 120.668 215.68C110.979 215.68 101.904 219.959 97.9054 229.132C93.2917 219.959 86.8316 215.68 76.5267 215.68C66.3755 215.68 58.8393 219.959 54.8403 229.132H54.5326V217.208H33Z"
          fill="#1C191B"
        />
        <path
          d="M218.887 245.487C218.887 237.997 219.348 230.201 214.58 224.087C209.966 218.125 202.276 215.68 195.047 215.68C186.588 215.68 177.667 220.112 174.744 227.908H174.437V189.999H151.828V294.861H174.437V252.978C174.437 248.391 174.437 243.5 176.436 239.373C178.282 235.551 183.05 233.564 187.203 233.564C197.047 233.564 196.277 246.251 196.277 252.978V294.861H218.887V245.487Z"
          fill="#1C191B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M227.267 217.208V321H249.876V286.301H250.184C253.414 293.179 260.489 296.39 268.179 296.39C290.942 296.39 298.017 275.295 298.017 256.188C298.017 246.71 297.094 237.386 292.173 229.132C286.943 220.265 279.561 215.68 269.102 215.68C259.105 215.68 252.952 220.112 248.8 228.673H248.492V217.208H227.267ZM249.876 251.296C249.876 246.71 249.876 241.971 252.183 237.844C254.183 234.023 257.874 231.577 262.335 231.577C273.716 231.577 274.331 247.627 274.331 255.575C274.331 263.524 273.87 280.492 262.181 280.492C258.182 280.492 254.183 278.046 252.029 274.684C249.414 270.403 249.876 263.83 249.876 258.939V251.296Z"
          fill="white"
        />
        <path
          d="M304.857 294.861H327.466V189.999H304.857V294.861Z"
          fill="white"
        />
        <path
          d="M403.105 294.861V217.208H380.495V258.939C380.495 262.913 380.803 267.346 379.265 270.862C377.265 275.448 372.959 278.352 367.883 278.352C359.885 278.352 359.27 272.391 359.27 266.124V217.208H336.66V266.124C336.66 273.613 336.2 280.95 340.506 287.677C344.966 294.708 351.733 296.39 359.578 296.39C370.19 296.39 378.188 291.345 381.879 281.562H382.187V294.861H403.105Z"
          fill="white"
        />
        <path
          d="M475.772 236.01C470.389 221.488 460.392 215.68 445.011 215.68C428.4 215.68 411.636 222.558 411.636 241.666C411.636 251.449 417.788 259.398 427.016 262.608C431.938 264.289 444.857 266.582 450.24 267.194C454.393 267.652 459.008 268.569 459.008 273.767C459.008 279.575 449.625 281.104 445.319 281.104C438.09 281.104 429.631 278.658 428.092 270.709L408.559 273.461C412.712 290.887 427.939 296.39 444.242 296.39C452.855 296.39 461.468 294.861 468.543 289.969C475.157 285.231 479.002 278.046 479.002 269.945C479.002 234.94 432.092 251.449 432.092 236.927C432.092 231.271 439.166 230.048 443.781 230.048C451.163 230.048 457.008 233.105 459.008 240.443L475.772 236.01Z"
          fill="white"
        />
      </g>
    </svg>
  );
}

export const Mhplus: InsuranceCorporateIdentity = {
  id: "mhplus",
  name: "mhplus Betriebskrankenkasse",
  logo: MhplusLogo,
  backgroundColor: "#8FCDF4",
  textColor: "#000000",
  wildcard: { or: ["mhplus", "textilgruppe"] },
  type: "statutory",
};
